// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("assets/js/" + chunkId + "." + "18c84306" + ".chunk.js");